module.exports = __webpack_public_path__ + "static/media/account.ac323e76.png";